import { useRightRail } from "@/context/RightRailContext";
import { cn } from "@/lib/utils";
import { RailNotificationsMount } from "./CollapsibleRailSection";
import { NotificationsList } from "./NotificationsList";

/** Animated notification stack — shared by right rail and Kai welcome overlay. */
export function NotificationsPanel({
  className,
  fill = false,
}: {
  className?: string;
  fill?: boolean;
}) {
  const {
    notificationsPanelActive,
    notificationsVisible,
    notificationsAnimating,
  } = useRightRail();

  if (!notificationsPanelActive) return null;

  return (
    <RailNotificationsMount
      open={notificationsVisible}
      animating={notificationsAnimating}
      fill={fill}
      className={className}
    >
      <div
        className={cn(
          "rail-notifications-scroll w-full min-w-0 max-w-full",
          fill ? "min-h-0 flex-1" : "max-h-[min(70vh,32rem)]",
        )}
      >
        <NotificationsList
          entering={notificationsVisible}
          exiting={notificationsAnimating && !notificationsVisible}
          className="box-border w-full min-w-0 max-w-full px-0.5 pb-1"
        />
      </div>
    </RailNotificationsMount>
  );
}
